<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="wrapperClass">
    <h3>FAQ</h3>
    <div v-for="(faq, index) in faqs" :key="index" class="faq" @click="faqOpen(index)">
      <p class="q">
        <a>{{ faq.question }}</a>
        <span class="icon" :class="{ open: faqOpenI === index }">&#x2c5;</span>
      </p>
      <p v-if="faqOpenI === index" class="a" v-html="faq.answer"></p>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";

defineProps({
  faqs: {
    type: Array,
    default: () => [],
  },
  wrapperClass: {
    type: String,
    default: "faq",
  },
});

const faqOpenI = ref(null);

const faqOpen = index => {
  faqOpenI.value = faqOpenI.value === index ? null : index;
};
</script>
